<mat-sidenav-container class="sidenav-container">
  <!-- Sidenav -->
  @if (isLoggedIn$ | async) {
    <mat-sidenav #sidenav mode="side" opened class="sidenav">
      <div class="py-3 px-4">
        <div class="mb-1">
          <img class="logo" src="assets/images/logo_cargosprint.svg" />
        </div>
      </div>
      <mat-list>
        @if (filteredSideNavMenuItems$ | async; as menuItems) {
          @for (menuItem of menuItems; track menuItem.route) {
            <ng-container *ngTemplateOutlet="menuTemplate; context: { item: menuItem }"></ng-container>
          }
        }
        @if (showGlobalMenu | async) {
          @for (menuItem of sideNavMenuItemGlobalAdmin; track menuItem.route) {
            <ng-container *ngTemplateOutlet="menuTemplate; context: { item: menuItem }"></ng-container>
          }
        }
        <span
          (click)="onLogout()"
          class="fw-normal px-4 py-2 d-flex flex-row align-items-center list-section-header list-section-header__action"
          >
          <mat-icon mat-list-icon class="me-3 material-symbols-outlined"> logout </mat-icon>
          Logout
        </span>
      </mat-list>
    </mat-sidenav>
  }

  <!-- Contenido Principal -->
  <mat-sidenav-content class="main-content">
    <!-- Barra Superior -->
    <mat-toolbar color="primary" class="top-toolbar">
      @if (isLoggedIn$ | async) {
        <button mat-icon-button (click)="toggleSidenav()">
          <mat-icon>menu</mat-icon>
        </button>
      }
      <div class="d-flex justify-content-end flex-grow-1">
        <span>Facilities Project Builder</span>
      </div>
    </mat-toolbar>

    <div class="content-router">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

<ng-template #menuTemplate let-item="item">
  <span
    class="fw-normal px-4 py-2 d-flex flex-row align-items-center list-section-header list-section-header__action"
    routerLink="/{{ item.route }}"
    [class.active]="isActiveRoute(item.route)"
    >
    <mat-icon mat-list-icon class="me-3 material-symbols-outlined">{{ item.icon }}</mat-icon>
    {{ item.label }}
  </span>
</ng-template>
